import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { useContext, useState } from 'react';
import { TextField } from 'formik-material-ui'
import { Formik, Form, Field } from 'formik';
import { EditIconButton } from 'components';
import { resolutionSchema, ITicketResolution, resolutionsContext } from '../ResolutionsContext';
import { applicationContext } from 'helpers/services';
import { ReferenceData } from 'helpers/enums';
import { Autocomplete } from 'formik-material-ui-lab';
import { TextField as MuiTextField } from "@material-ui/core"
import { ticketContext } from 'views/Ticket/TicketContext';


interface IProps {
    resolution?: ITicketResolution
}


let ResolutionEditor = (props: IProps) => {
    let { setStatusDialog } = useContext(ticketContext);
    let service = useContext(resolutionsContext);
    const { referenceData } = useContext(applicationContext)

    let [isOpen, setOpen] = useState(false);


    return (
        <>
            {!props.resolution &&
                <Button
                    color="secondary"
                    size="small"
                    variant="outlined"
                    onClick={() => setOpen(true)}
                >
                    <AddIcon />&nbsp;Add
                </Button>
            }
            {props.resolution && <EditIconButton onClick={() => setOpen(true)} />}

            <Dialog open={isOpen} fullWidth maxWidth="sm">
                <DialogTitle disableTypography>
                    <Typography variant="h4">Manual resolution</Typography>
                </DialogTitle>

                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        ...resolutionSchema.getDefault(),
                        ...props.resolution
                    }}
                    validationSchema={resolutionSchema}
                    onSubmit={async (values, action) => {
                        let res = await service.saveTicketResolution(values);
                        if (res.openDialog === true) {
                            setOpen(false);
                            action.resetForm();
                            setStatusDialog({ open: true, suggestedStatus: res.suggestedStatus })
                        }
                        else
                            action.setSubmitting(false)
                    }}
                >
                    {form =>
                        <Form>
                            <DialogContent>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Field
                                            fullWidth
                                            name="internalActions"
                                            component={Autocomplete}
                                            options={referenceData.getByKey(ReferenceData.InternalAction)?.values.map(x => x.key)}
                                            getOptionLabel={(option: string) => referenceData.getByKey(ReferenceData.InternalAction)?.values.getValueByKey(option)}
                                            renderInput={(params: any) =>
                                                <MuiTextField
                                                    {...params}
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="dense"
                                                    label="Internal actions"
                                                />
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            fullWidth
                                            name="actionToCustomer"
                                            component={Autocomplete}
                                            options={referenceData.getByKey(ReferenceData.ActionToCustomer)?.values.map(x => x.key)}
                                            getOptionLabel={(option: string) => referenceData.getByKey(ReferenceData.ActionToCustomer)?.values.getValueByKey(option)}
                                            renderInput={(params: any) =>
                                                <MuiTextField
                                                    {...params}
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="dense"
                                                    label="Action to customer"
                                                />
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            fullWidth
                                            name="defect"
                                            component={Autocomplete}
                                            options={referenceData.getByKey(ReferenceData.Defect)?.values.map(x => x.key)}
                                            getOptionLabel={(option: string) => referenceData.getByKey(ReferenceData.Defect)?.values.getValueByKey(option)}
                                            renderInput={(params: any) =>
                                                <MuiTextField
                                                    {...params}
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="dense"
                                                    label="Defect"
                                                />
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            fullWidth
                                            name="defectCause"
                                            component={Autocomplete}
                                            options={referenceData.getByKey(ReferenceData.DefectCause)?.values.map(x => x.key)}
                                            getOptionLabel={(option: string) => referenceData.getByKey(ReferenceData.DefectCause)?.values.getValueByKey(option)}
                                            renderInput={(params: any) =>
                                                <MuiTextField
                                                    {...params}
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="dense"
                                                    label="Defect Cause"
                                                />
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            fullWidth
                                            name="subDefect"
                                            component={Autocomplete}
                                            options={referenceData.getByKey(ReferenceData.SubDefect)?.values.map(x => x.key)}
                                            getOptionLabel={(option: string) => referenceData.getByKey(ReferenceData.SubDefect)?.values.getValueByKey(option)}
                                            renderInput={(params: any) =>
                                                <MuiTextField
                                                    {...params}
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="dense"
                                                    label="Sub-defect"
                                                />
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Non conformity number"
                                            name="nonConformityNumber"
                                            variant="outlined"
                                            size="small"
                                            margin="dense"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Error Symptom"
                                            name="errorSymptom"
                                            variant="outlined"
                                            size="small"
                                            margin="dense"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Notes"
                                            name="notes"
                                            variant="outlined"
                                            size="small"
                                            margin="dense"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>

                            <DialogActions>
                                <Button color="primary" disabled={form.isSubmitting} onClick={() => setOpen(false)}>Cancel</Button>
                                <Button color="secondary" type="submit" disabled={form.isSubmitting}>Save</Button>
                            </DialogActions>
                        </Form>
                    }
                </Formik>
            </Dialog>
        </>
    )
}

export default ResolutionEditor;